import { catalogRowForPick } from '../data/regionsCatalog';
import { getCountryCodeForCity } from '../api/regionWaitlistApi';
import { normalizeLangKey } from './localeLangKey';

/** Optional localized city names (English pick key → per-locale label) */
const PICK_ALT = {
  'Da Nang': { vi: 'Đà Nẵng', ja: 'ダナン', th: 'ดานัง', id: 'Da Nang', 'zh-CN': '岘港', 'zh-TW': '蚬港', ru: 'Дананг', hi: 'दा नांग' },
  'Ho Chi Minh': { vi: 'TP. Hồ Chí Minh', ja: 'ホーチミン', th: 'โฮจิมินห์', id: 'Ho Chi Minh', 'zh-CN': '胡志明市', 'zh-TW': '胡志明市', ru: 'Хошимин', hi: 'हो चि मिन्ह' },
  Hanoi: { vi: 'Hà Nội', ja: 'ハノイ', th: 'ฮานอย', id: 'Hanoi', 'zh-CN': '河内', 'zh-TW': '河內', ru: 'Ханой', hi: 'हनोई' },
  Bangkok: { vi: 'Băng Cốc', ja: 'バンコク', th: 'กรุงเทพฯ', id: 'Bangkok', 'zh-CN': '曼谷', 'zh-TW': '曼谷', ru: 'Бангкок', hi: 'बैंकॉक' },
  Manila: { vi: 'Manila', ja: 'マニラ', th: 'มะนิลา', id: 'Manila', 'zh-CN': '马尼拉', 'zh-TW': '馬尼拉', ru: 'Манила', hi: 'मनीला' },
  Singapore: { vi: 'Singapore', ja: 'シンガポール', th: 'สิงคโปร์', id: 'Singapura', 'zh-CN': '新加坡', 'zh-TW': '新加坡', ru: 'Сингапур', hi: 'सिंगापुर' },
  Tokyo: { vi: 'Tokyo', ja: '東京', th: 'โตเกียว', id: 'Tokyo', 'zh-CN': '东京', 'zh-TW': '東京', ru: 'Токио', hi: 'टोक्यो' },
  Shanghai: { vi: 'Thượng Hải', ja: '上海', th: 'เซี่ยงไฮ้', id: 'Shanghai', 'zh-CN': '上海', 'zh-TW': '上海', ru: 'Шанхай', hi: 'शंघाई' },
  Taipei: { vi: 'Đài Bắc', ja: '台北', th: 'ไทเป', id: 'Taipei', 'zh-CN': '台北', 'zh-TW': '台北', ru: 'Тайбэй', hi: 'ताइपे' },
  Sydney: { vi: 'Sydney', ja: 'シドニー', th: 'ซิดนีย์', id: 'Sydney', 'zh-CN': '悉尼', 'zh-TW': '雪梨', ru: 'Сидней', hi: 'सिडनी' },
  'Los Angeles': { vi: 'Los Angeles', ja: 'ロサンゼルス', th: 'ลอสแอนเจลิส', id: 'Los Angeles', 'zh-CN': '洛杉矶', 'zh-TW': '洛杉磯', ru: 'Лос-Анджелес', hi: 'लॉस एंजिल्स' },
  London: { vi: 'Luân Đôn', ja: 'ロンドン', th: 'ลอนดอน', id: 'London', 'zh-CN': '伦敦', 'zh-TW': '倫敦', ru: 'Лондон', hi: 'लंदन' },
  Paris: { vi: 'Pari', ja: 'パリ', th: 'ปารีส', id: 'Paris', 'zh-CN': '巴黎', 'zh-TW': '巴黎', ru: 'Париж', hi: 'पेरिस' },
};

/**
 * @param {string} pick — stored region label (English)
 * @param {string} language — UI locale code
 */
export function localizedPrimaryCityLabel(pick, language) {
  const row = catalogRowForPick(pick);
  const lang = normalizeLangKey(language);
  if (lang === 'ko') return row?.ko || pick;
  const alt = PICK_ALT[pick];
  if (alt && alt[lang]) return alt[lang];
  return pick;
}

/**
 * @param {string} pick
 * @param {string} language
 * @param {(k: string) => string} t
 */
export function formatHomeRegionLine(pick, language, t) {
  const cc = getCountryCodeForCity(pick) || 'VN';
  const city = localizedPrimaryCityLabel(pick, language);
  const country = t(`countries.${cc}`) || cc;
  return `${city}, ${country}`;
}
